import {
  CHANNEL_TABLE,
  CHANNEL_IS_FETCHING,
  CHANNEL_IS_FETCHING_ID,
  CHANNEL_SUCCESS,
  CHANNEL_CREATE,
  CHANNEL_DELETE,
  CHANNEL_UPDATE,
  CHANNEL_SELECT,
  CHANNEL_SELECT_DIRECTORY,
  CHANNEL_EDIT_DIRECTORY,
  CHANNEL_SELECT_PREVIOUS_DIRECTORY,
  CHANNEL_CREATE_DIRECTORY,
  CHANNEL_CREATE_SMART_DIRECTORY,
  CHANNEL_ASSIGN_FILES,
  CHANNEL_UNASSIGN_FILES,
  CHANNEL_DELETE_DIRECTORIES,
  CHANNEL_ADD_USERS,
  CHANNEL_DELETE_USERS,
  CHANNEL_ADD_GROUPS,
  CHANNEL_DELETE_GROUPS
} from '../types'

const initialState = {
  isFetching: false,
  isFetchingId: false,

  table: {
    checkedList: [],
    indeterminate: false,
    checkAll: false
  },

  selectedDirectoryStack: [],
  selectedDirectory: {
    smartDirs: [],
    dirs: [],
    files: []
  },
  selectedChannel: {
    dirs: [],
    files: []
  },
  list: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case CHANNEL_TABLE:
      return {
        ...state,
        table: action.payload
      }

    case CHANNEL_IS_FETCHING:
      return {
        ...state,
        isFetching: action.payload
      }

    case CHANNEL_IS_FETCHING_ID:
      return {
        ...state,
        isFetchingId: action.payload
      }

    case CHANNEL_SUCCESS:
      return {
        ...state,
        list: action.payload
      }

    case CHANNEL_CREATE:
      return {
        ...state,
        list: [
          ...state.list,
          action.payload
        ]
      }

    case CHANNEL_DELETE:
      return {
        ...state,
        list: state.list.filter(item => item.id !== action.payload.id),
        selectedChannel: initialState.selectedChannel,
        selectedDirectory: initialState.selectedDirectory,
        selectedDirectoryStack: initialState.selectedDirectoryStack
      }

    case CHANNEL_UPDATE:
      return {
        ...state,
        list: state.list.map(item => item.id === action.payload.id ? action.payload : item),
        selectedChannel: action.payload
      }

    case CHANNEL_SELECT:
      return {
        ...state,
        selectedChannel: action.payload,
        selectedDirectory: initialState.selectedDirectory,
        selectedDirectoryStack: initialState.selectedDirectoryStack,
        table: initialState.table
      }

    case CHANNEL_SELECT_DIRECTORY:
      return {
        ...state,
        selectedDirectory: action.payload,
        selectedDirectoryStack: [
          ...state.selectedDirectoryStack,
          action.payload.id
        ]
      }

    case CHANNEL_EDIT_DIRECTORY:
      return {
        ...state,
        selectedChannel: {
          ...state.selectedChannel,
          smartDirs: state.selectedChannel.smartDirs.map(dir => dir.id === action.payload.id ? action.payload : dir),
          dirs: state.selectedChannel.dirs.map(dir => dir.id === action.payload.id ? action.payload : dir)
        },
        selectedDirectory: action.payload
      }

    case CHANNEL_SELECT_PREVIOUS_DIRECTORY:

      return {
        ...state,
        selectedDirectory: action.payload,
        selectedDirectoryStack: state.selectedDirectoryStack.slice(0, -1)
      }

    case CHANNEL_CREATE_DIRECTORY:

      action.payload = { ...action.payload, dirs: [], files: [] }

      if (state.selectedDirectory.id) {
        return {
          ...state,
          selectedDirectory: {
            ...state.selectedDirectory,
            dirs: [
              ...state.selectedDirectory.dirs,
              action.payload
            ]
          }
        }
      }

      return {
        ...state,
        selectedChannel: {
          ...state.selectedChannel,
          dirs: [
            ...state.selectedChannel.dirs,
            action.payload
          ]
        }
      }

    case CHANNEL_CREATE_SMART_DIRECTORY:

      action.payload = { ...action.payload, smartDirs: [], dirs: [] }

      if (state.selectedDirectory.id) {
        return {
          ...state,
          selectedDirectory: {
            ...state.selectedDirectory,
            smartDirs: [
              ...state.selectedDirectory.smartDirs,
              action.payload
            ]
          }
        }
      }

      return {
        ...state,
        selectedChannel: {
          ...state.selectedChannel,
          smartDirs: [
            ...state.selectedChannel.smartDirs,
            action.payload
          ]
        }
      }

    case CHANNEL_ASSIGN_FILES:

      if (state.selectedDirectory.id) {
        return {
          ...state,
          selectedDirectory: {
            ...state.selectedDirectory,
            files: [
              ...state.selectedDirectory.files,
              ...action.payload
            ]
          }
        }
      }

      return {
        ...state,
        selectedChannel: {
          ...state.selectedChannel,
          files: [
            ...state.selectedChannel.files,
            ...action.payload
          ]
        }
      }

    case CHANNEL_UNASSIGN_FILES:

      if (state.selectedDirectory.id) {
        return {
          ...state,
          selectedDirectory: {
            ...state.selectedDirectory,
            files: [
              ...state.selectedDirectory.files.filter(x => !action.payload.filter(y => y.id === x.id).length)
            ]
          }
        }
      }

      return {
        ...state,
        selectedChannel: {
          ...state.selectedChannel,
          files: [
            ...state.selectedChannel.files.filter(x => !action.payload.filter(y => y.id === x.id).length)
          ]
        }
      }

    case CHANNEL_DELETE_DIRECTORIES:

      if (state.selectedDirectory.id) {
        return {
          ...state,
          selectedDirectory: {
            ...state.selectedDirectory,
            dirs: [
              ...state.selectedDirectory.dirs.filter(x => !action.payload.filter(y => y.id === x.id).length)
            ],
            smartDirs: [
              ...state.selectedDirectory.smartDirs.filter(x => !action.payload.filter(y => y.id === x.id).length)
            ]
          }
        }
      }

      return {
        ...state,
        selectedChannel: {
          ...state.selectedChannel,
          dirs: [
            ...state.selectedChannel.dirs.filter(x => !action.payload.filter(y => y.id === x.id).length)
          ],
          smartDirs: [
            ...state.selectedChannel.smartDirs.filter(x => !action.payload.filter(y => y.id === x.id).length)
          ]
        }
      }

    case CHANNEL_ADD_USERS:
      return {
        ...state,
        selectedChannel: {
          ...state.selectedChannel,
          users: [
            ...state.selectedChannel.users,
            ...action.payload
          ]
        }
      }
    case CHANNEL_DELETE_USERS:
      return {
        ...state,
        selectedChannel: {
          ...state.selectedChannel,
          users: state.selectedChannel.users.filter(x => !action.payload.filter(y => y.id === x.id).length)
        }
      }
    case CHANNEL_ADD_GROUPS:
      return {
        ...state,
        selectedChannel: {
          ...state.selectedChannel,
          groups: [
            ...state.selectedChannel.groups,
            ...action.payload
          ]
        }
      }
    case CHANNEL_DELETE_GROUPS:
      return {
        ...state,
        selectedChannel: {
          ...state.selectedChannel,
          groups: state.selectedChannel.groups.filter(x => !action.payload.filter(y => y.id === x.id).length)

        }
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/channel.js